export default {
    set(state, { data }) {
      state.matrizes = data;
    },
    show(state, { data }) {
      state.matriz = data;
    }
  }